import React from 'react';
import { SContributingFactors } from './ContributingFactors';
import ToggleBar from './reusableObjects/ToggleBar';
import { additionalPests } from '../Content';
import styled from 'styled-components';

const AdditionlPests = ({ industry }) => {
  return (
    <SAdditionlPests>
      <hr/>
      <h4>Additional Pests That May Be Present</h4>
      <ul className='list'>
        {(industry === 'Healthcare' || industry === 'Hospitality') &&
          <li><img  src={'https://pest-pressure.netlify.com' + additionalPests[0].icon} alt={additionalPests[0].icon} />{additionalPests[0].label}</li>
        }
        {(industry === 'Food & Beverage Manufacturing' || industry === 'Manufacturing' || industry === 'Food Retail Service') &&
          <li><img src={'https://pest-pressure.netlify.com' + additionalPests[2].icon} alt={additionalPests[2].icon} />{additionalPests[2].label}</li>
        }
        {(industry === 'Food & Beverage Manufacturing' || industry === 'Food Retail Service' || industry === 'Manufacturing') &&
          <li><img src={'https://pest-pressure.netlify.com' + additionalPests[4].icon} alt={additionalPests[4].icon} />{additionalPests[4].label}</li>
        }
        <li><img src={'https://pest-pressure.netlify.com' + additionalPests[1].icon} alt={additionalPests[1].icon} />{additionalPests[1].label}</li>
        <li><img src={'https://pest-pressure.netlify.com' + additionalPests[3].icon} alt={additionalPests[3].icon} />{additionalPests[3].label}</li>
      </ul>
      <SContributingFactors>
      <ToggleBar>
      <div>
        {(industry === 'Healthcare' || industry === 'Hospitality') &&
          <>
            <strong>{additionalPests[0].label}</strong>
            <ul>
              {additionalPests[0].items.map(item => (
                <li key={Math.random()}>
                  {item}
                </li>
              ))}
            </ul>
          </>
        }
        {(industry === 'Food & Beverage Manufacturing' || industry === 'Manufacturing' || industry === 'Food Retail Service') &&
          <>
            <strong>{additionalPests[2].label}</strong>
            <ul>
              {additionalPests[2].items.map(item => (
                <li key={Math.random()}>
                  {item}
                </li>
              ))}
            </ul>
          </>
        }
        {(industry === 'Food & Beverage Manufacturing' || industry === 'Food Retail Service' || industry === 'Manufacturing') &&
          <>
            <strong>{additionalPests[4].label}</strong>
            <ul>
              {additionalPests[4].items.map(item => (
                <li key={Math.random()}>
                  {item}
                </li>
              ))}
            </ul>
          </>
        }
        <strong>{additionalPests[1].label}</strong>
        <ul>
          {additionalPests[1].items.map(item => (
            <li key={Math.random()}>
              {item}
            </li>
          ))}
        </ul>
        <strong>{additionalPests[3].label}</strong>
        <ul>
          {additionalPests[3].items.map(item => (
            <li key={Math.random()}>
              {item}
            </li>
          ))}
        </ul>
      </div>
      </ToggleBar>
      </SContributingFactors>
    </SAdditionlPests>
  );
};

export default AdditionlPests;

const SAdditionlPests = styled.div`
  h4 {
    font-size: 22px;
  }


  .list {
    margin: 0 !important;


    li {
      display: inline-block;
      list-style-type: none;
      margin: 0 10px 15px 0;
      position: relative;
      padding-left: 42px;
      font-size: 14px;

      img {
        display: block;
        max-height: 30px;
        max-width: 30px;
        height: auto;
        width: auto;
        position: absolute;
        top: 50%;
        left: 5px;
        transform: translateY(-50%);
      }
    }
  }
`;
